export const SET_VISIBILITY="SET_VISIBILITY"
